import wSwitch from './w-switch.vue';

import { installer } from '#util';

export const Switch = { install: installer([wSwitch]) };
export { wSwitch };
